import axios from 'axios'
const uuidv4 = require('uuid/v4')

/*
Tried to control this in /config javascript files
Using API_URL or BACKEND_URL
However, it always showed up as undefined
when using as process.env.
 */

let url = ''
switch (process.env.NODE_ENV) {
  case 'production':
    // This case is for remote deployments, not just production.
    // The following are URLs to use for each of the standard remote
    // environments.
    //
    // Production:     https://scms-api.smartpay.com/
    // Staging:        https://scms-api.staging.smartpay.com/
    // Development:    https://scms-api.dev.smartpay.com/
    url = 'https://scms-api.smartpay.com/'
    break

  case 'testing':
    // I have no idea what utility this case gives us.  Perhaps it will be
    // useful for unit testing eventually?
    url = ''
    break

  case 'development':
  default:
    // This case is used for local development, i.e. running the UI locally from
    // the unpackaged code.  The Development SCMS service instance can also be
    // used here.  NEVER run this against the Production SCMS service.
    // url = 'http://localhost:5000/'
    url = 'https://scms-api.dev.smartpay.com:8443/'
}

/**
 * Timeouts for calls with preflight requests encompass the combined time for
 * the preflight call and the actual call.  e.g. If the timeout is set to 20
 * seconds and the preflight call takes 8 seconds, then the actual call only has
 * 12 seconds to complete before timing out.
 *
 * On my mobile connection I saw enough instances where either the
 * preflight or the actual call to retrieve file references took about 8
 * seconds to convince me that setting the timeout value to over 16 seconds is
 * warranted.  Rarely did I see both spike like that, but it is possible.
 * We may even consider setting the timeout higher if we still have users
 * that cannot connect.  This may be affected by carrier, location, and time
 * of day (e.g. peak usage times).
 *
 * @type {AxiosInstance}
 */
export const BACKEND_SERVICE = axios.create({
  baseURL: url,
  timeout: 20000,
  headers: {
    'X-REQUEST-ID': uuidv4()
  }
})



// WEBPACK FOOTER //
// ./src/http-common-service.js